import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("a1_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Offline / Cloudflare readiness: cache successful GET responses and serve
// them from localStorage when the backend/DB is unreachable, so charts,
// MTD reports, filters and receipts remain testable without a live DB.
const cacheKey = (config) => `a1_cache:${config.url}?${JSON.stringify(config.params || {})}`;

api.interceptors.response.use(
  (res) => {
    try {
      if (res.config.method === "get") {
        localStorage.setItem(cacheKey(res.config), JSON.stringify(res.data));
      }
    } catch (_) {}
    return res;
  },
  (err) => {
    const cfg = err.config || {};
    const noResponse = !err.response; // network error / offline
    if (noResponse && (cfg.method === "get" || cfg.method === undefined)) {
      try {
        const cached = localStorage.getItem(cacheKey(cfg));
        if (cached) {
          return Promise.resolve({ data: JSON.parse(cached), cached: true, config: cfg });
        }
      } catch (_) {}
    }
    return Promise.reject(err);
  }
);

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong";
}
